const attributes = ['frameBoreder', 'allow', 'allowfullscreen', 'scrolling', 'allowtransparency'];

export default attributes;
